var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "m15 3 1.85 2H20c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 21H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 19V7c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 5h3.15L9 3h6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "m14.125 5 1.825 2H20v12H4V7h4.05l1.825-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M12 8.5c1.25 0 2.313.438 3.188 1.313.874.874 1.312 1.937 1.312 3.187 0 1.25-.438 2.313-1.313 3.188-.874.875-1.937 1.312-3.187 1.312-1.25 0-2.313-.438-3.188-1.313C7.939 15.313 7.5 14.25 7.5 13c0-1.25.438-2.313 1.313-3.188C9.687 8.938 10.75 8.5 12 8.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M12 10.5c-.7 0-1.292.242-1.775.725C9.742 11.708 9.5 12.3 9.5 13s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725s1.292-.242 1.775-.725c.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C13.292 10.742 12.7 10.5 12 10.5z"
}))));
export default SvgImageIcon;